/**
 *
 * @module adobeRegistration
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../../exception/invalidArgumentException';

const {
    nonEmptyString,
    number
} = Check.assert;

/**
 *
 * @class AdobeRegistration
 * @desc The response when the client has created a registration code.
 *
 */
export default class AdobeRegistration {

    /**
     *
     * @param {String} code
     * @param {Number} generatedAt
     * @param {Number} expiresAt
     *
     */
    constructor(code, generatedAt, expiresAt) {

        const errorMessage = {
            ctor: 'AdobeRegistration(code, generatedAt, expiresAt)',
            get code() {
                return `${this.ctor} code should be a String with length`;
            },
            get generatedAt() {
                return `${this.ctor} generatedAt should be a Number`;
            },
            get expiresAt() {
                return `${this.ctor} expiresAt should be a Number`;
            }
        };

        nonEmptyString(code, errorMessage.code, InvalidArgumentException);
        number(generatedAt, errorMessage.generatedAt, InvalidArgumentException);
        number(expiresAt, errorMessage.expiresAt, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets a code an adobe user needs to authorize so they can access content.
         *
         */
        this.code = code;

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets the timestamp of the moment at which the registration code was generated.
         *
         */
        this.generatedAt = generatedAt;

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets the expiration timestamp of the registration code.
         *
         */
        this.expiresAt = expiresAt;

    }

}



// WEBPACK FOOTER //
// ./src/services/identity/adobe/adobeRegistration.js